__turbopack_context__.v({
  "clearButton": "RefNumberFilter-module-scss-module__7NZIta__clearButton",
  "container": "RefNumberFilter-module-scss-module__7NZIta__container",
  "input": "RefNumberFilter-module-scss-module__7NZIta__input",
});
